import './App.css';
import Router from "./routes/routes";
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function App() {
  return (
    <>
     <ToastContainer style={{ zIndex: 999999 }} />
      <BrowserRouter>
        <Router />
      </BrowserRouter>
      </>
  );
}

export default App;
